var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderAccount = function SvgHeaderAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.731,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.865 12q-2.447 0-4.19-1.762Q5.933 8.475 5.933 6t1.742-4.237T11.865 0q2.448 0 4.19 1.763T17.798 6t-1.743 4.238Q14.313 12 11.865 12M0 21v-1.2q0-1.275.649-2.344a4.35 4.35 0 0 1 1.724-1.631 22 22 0 0 1 4.672-1.744 20.2 20.2 0 0 1 4.82-.581q2.448 0 4.82.581 2.374.582 4.673 1.744a4.35 4.35 0 0 1 1.724 1.631q.648 1.07.649 2.344V21q0 1.237-.872 2.119a2.84 2.84 0 0 1-2.095.881H2.966a2.84 2.84 0 0 1-2.095-.881A2.9 2.9 0 0 1 0 21"
  })));
};
export default SvgHeaderAccount;